<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card
            class="text-center"
        >
            <v-card-title class="d-flex justify-center">
                <h2 class="text-h4 font-weight-bold">
                    Zmień status
                </h2>
            </v-card-title>

            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12" md="12" lg="12" class="d-flex align-center justify-center">
                            <v-chip
                                color="success"
                                text-color="black"
                                class="pa-4 text-uppercase"
                            >
                                {{ statusFrom ? statusFrom.name : 'Nieznany' }}
                            </v-chip>
                            <span class="text-h4 font-weight-bold ma-4 black--text">
                                na
                            </span>
                            <v-chip
                                color="primary"
                                text-color="black"
                                class="pa-4 text-uppercase"
                            >
                                {{ statusTo ? statusTo.name : 'Nieznany' }}
                            </v-chip>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    @click="onSuccess"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'ChangeStatusDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        statusFrom: {
            type: Object,
            default: null
        },
        statusTo: {
            type: Object,
            default: null
        }
    },
    methods: {
        onSuccess() {
            this.$emit('on-success')
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>
